if (window.calcMethod) {
    const showBothCalculationMethod = window.calcMethod === 'PCP/HP';

    const switchButton = document.querySelector('.switch-button');
    const switchBtnRight = document.querySelector('.switch-button-case.right');
    const switchBtnLeft = document.querySelector('.switch-button-case.left');
    const activeSwitch = document.querySelector('.switch-button .active');

    if (showBothCalculationMethod) {
        switchBtnLeft.addEventListener('click', function () {
            switchToPCP();
        }, false);

        switchBtnRight.addEventListener('click', function () {
            switchToHP();
        }, false)

        window.calcMethod = window.defaultCalcMethod !== "" ? window.defaultCalcMethod : 'PCP';
    }

    let calcMethod = window.calcMethod;
    const creditScore = document.querySelector("#credit-score-dropdown #credit-rating");
    const creditScoreIcon = document.querySelector("#credit-score-dropdown svg");
    const loanSlider = document.querySelector('#loan-slider .range-slider');
    const loanOutput = document.querySelector('#loan-slider output');
    const termSlider = document.querySelector('#term-slider .range-slider');
    const termOutput = document.querySelector('#term-slider output');
    const depositAmount = document.querySelector('#deposit-amount');
    const carPrice = document.querySelector('#deposit-amount');
    const monthlyBudget = document.querySelector('#estimated-monthly-budget strong');
    const totalCostOfCreditOutput = document.querySelector('#total-cost-of-credit');
    const optionalFinalPayment = document.querySelector('#optional-final-payment');

    function updateSlider(slider, value) {
        const min = slider.getAttribute("min");
        const max = slider.getAttribute("max");
        const currentValue = value || slider.value;
        slider.style.backgroundSize = `${((currentValue - min) * 100) / (max - min)}% 100%`;
    }

    window.updateLoanSlider = function (value) {
        updateSlider(loanSlider, value);
    }
    window.updateTermSlider = function (value) {
        updateSlider(termSlider, value);
    }
    window.updateLoanSlider();
    window.updateTermSlider();

    loanSlider.addEventListener("input", function (e) {
        window.updateLoanSlider(e.target.value);
    });
    termSlider.addEventListener("input", function (e) {
        window.updateTermSlider(e.target.value);
    });

    function switchToPCP() {
        calcMethod = "PCP";
        if (termSlider.value > 48) {
            termSlider.value = 48;
            termOutput.value = '48 months';
        }

        termSlider.max = 48;
        window.updateTermSlider();

        if (showBothCalculationMethod) {
            switchBtnRight.classList.remove('active-case');
            switchBtnLeft.classList.add('active-case');
            activeSwitch.style.left = '4px';
        }

        calculateAndDisplay();
    }

    function switchToHP() {
        calcMethod = "HP";
        termSlider.max = 60;
        termSlider.value = 60;
        termOutput.value = '60 months';

        window.updateTermSlider();

        if (showBothCalculationMethod) {
            switchBtnRight.classList.add('active-case');
            switchBtnLeft.classList.remove('active-case');
            activeSwitch.style.left = '50%';
        }

        calculateAndDisplay();
    }

    function formatMoney(amount) {
        return new Intl.NumberFormat("en-GB", {
            style: "currency",
            currency: "GBP",
            maximumFractionDigits: 2
        }).format(amount);
    }

    function getDepositOptions(carPrice) {
        const depositOptions = [0, 250, 500, 750, 1000, 1250, 1500, 1750, 2000, 2500, 3000, 4000, 5000, 7500, 10000, 15000, 20000, 25000, 30000, 40000, 50000, 60000, 70000, 80000, 90000, 100000];
        const selectOptions = [];

        for (let i = 0; i < depositOptions.length; i++) {
            const v = depositOptions[i];
            if (depositOptions[i] > (carPrice * .5)) break;
            selectOptions.push(`<option value="${v}">${v !== 0 ? v : "No Deposit"}</option>`);
        }
        return selectOptions;
    }

    function creditScoreRatingToApr(creditScore) {
        switch (creditScore) {
            case "Excellent":
                return 9.9;
            case "Good":
                return 11.9;
            case "Fair":
                return 16.9;
            case "Poor":
                return 23.9;
            case "Bad":
                return 31.9;
            default:
                return 9.9;
        }
    }

    function termToResidualValuePercent(term) {
        switch (term) {
            case 12:
                return 68;
            case 24:
                return 60;
            case 36:
                return 46;
            case 48:
                return 36;
        }
    }

    function calcPCP() {
        const PMT = (rate, nper, pv, fv, type) => {
            /*
             * rate   - interest rate per month
             * nper   - number of periods (months)
             * pv   - present value
             * fv   - future value
             * type - when the payments are due:
             *        0: end of the period, e.g. end of month (default)
             *        1: beginning of period
             */
            let pmt, pvif;

            fv || (fv = 0);
            type || (type = 0);

            if (rate === 0)
                return -(pv + fv) / nper;

            pvif = Math.pow(1 + rate, nper);
            pmt = -rate * (pv * pvif + fv) / (pvif - 1);

            if (type === 1)
                pmt /= (1 + rate);

            return pmt;
        }

        let apr = creditScoreRatingToApr(creditScore.value);
        let term = termSlider.value;
        let advance = loanSlider.value;

        let residualValuePercent = termToResidualValuePercent(+term);
        let deposit = +depositAmount.value;

        let rate = (apr / 100) / 12;
        let nper = term;
        let pv = -Math.abs(advance - deposit);
        let fv = advance / 100 * residualValuePercent;

        const payment = PMT(rate, nper, pv, fv, 0);

        monthlyBudget.innerHTML = formatMoney(payment);
        totalCostOfCreditOutput.innerHTML = formatMoney((payment * term) - advance + deposit + fv);
        optionalFinalPayment.innerHTML = formatMoney(fv);
    }

    function calcHP() {
        const amount = loanSlider.value;
        const deposit = depositAmount.value;
        const termMonths = termSlider.value;
        const apr = creditScoreRatingToApr(creditScore.value);
        const monthlyInterest = Math.pow((apr / 100) + 1, 1 / 12) - 1;
        const pmt = monthlyInterest + (monthlyInterest / (Math.pow(1 + monthlyInterest, termMonths) - 1));
        const netAmount = amount - deposit;
        const monthlyRepayment = Math.round(netAmount * pmt * 100) / 100;
        const totalRepayable = Math.round(monthlyRepayment * termMonths * 100) / 100;
        const costOfCredit = totalRepayable - netAmount;

        monthlyBudget.innerHTML = formatMoney(monthlyRepayment);
        totalCostOfCreditOutput.innerHTML = formatMoney(costOfCredit);
        optionalFinalPayment.innerHTML = formatMoney(0);
    }

    depositAmount.innerHTML = getDepositOptions(100000);

    creditScore.addEventListener('input', (e) => {
        creditScoreIcon.removeAttribute("class");
        creditScoreIcon.classList.add(e.target.value.toLowerCase());
        calculateAndDisplay();
    });
    loanSlider.addEventListener('input', (e) => {
        loanOutput.value = formatMoney(e.target.value);
        calculateAndDisplay();
    });
    termSlider.addEventListener('input', (e) => {
        termOutput.value = e.target.value + ' months';
        calculateAndDisplay();
    });
    depositAmount.addEventListener('input', (e) => {
        calculateAndDisplay();
    });

    function calculateAndDisplay() {
        if (calcMethod === 'PCP') {
            calcPCP();
        } else {
            calcHP();
        }
    }

    calculateAndDisplay();

    if (calcMethod === 'HP') {
        switchToHP();
        termSlider.value = "60";
        termOutput.innerHTML = "60 months";
        window.updateTermSlider();
        calculateAndDisplay();
    }
}